/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_LinearInputs */

const en_mk_calc_row_linear = /** @type {(inputs: Mk_Calc_Row_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear Business`)
};

const id_mk_calc_row_linear = /** @type {(inputs: Mk_Calc_Row_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linear Business`)
};

/**
* | output |
* | --- |
* | "Linear Business" |
*
* @param {Mk_Calc_Row_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_linear = /** @type {((inputs?: Mk_Calc_Row_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_linear(inputs)
	return en_mk_calc_row_linear(inputs)
});